var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderMobileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 60,
    viewBox: "0 0 180 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_720_4301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 29.6903C0.5 13.2931 13.7926 0.000488281 30.1898 0.000488281H149.51C165.907 0.000488281 179.199 13.2931 179.199 29.6903C179.199 46.0875 165.907 59.3801 149.51 59.3801H30.1898C13.7926 59.3801 0.5 46.0875 0.5 29.6903Z",
    fill: "url(#paint0_linear_720_4301)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9482 28.8601V19.77H46.0601C46.0601 19.77 46.0566 23.4291 46.046 25.2447C46.0425 26.454 45.4312 27.4062 44.6168 28.0937C44.2748 28.3863 43.7812 28.6366 43.129 28.8446C41.5214 29.3558 40.3192 29.3276 38.151 29.3981C36.977 29.4369 35.6374 29.6167 34.5409 29.8599C32.6724 30.2795 30.9661 31.1503 29.4184 32.4723C28.7239 33.0681 28.1492 34.027 27.7015 35.3526C27.638 35.5324 27.6803 35.5641 27.8319 35.4443C28.2867 35.0776 28.6005 34.5171 29.0553 34.161C30.3491 33.1421 31.7205 32.4864 33.1766 32.1867C35.3306 31.7425 37.876 31.8624 40.0054 32.712C40.4567 32.8918 40.9467 33.0505 41.4791 33.1809C42.3499 33.3995 43.1008 33.3784 43.7319 33.1175C44.8636 32.6486 45.5369 31.7461 45.752 30.3535C45.8183 29.8236 46.046 29.6495 46.046 29.6495V39.5338L26.5698 39.5374C26.2948 39.3399 24.5493 34.7945 28.6428 31.5275C29.8993 30.5245 31.0789 29.7929 32.1859 29.3417C36.8819 27.4238 39.3462 26.4155 39.5753 26.3204C40.5025 25.929 41.3345 25.4425 42.0714 24.8608C43.0479 24.0887 44.1056 22.7067 43.0444 21.6279C42.4416 21.0145 41.6554 20.81 40.6929 21.0145C37.9853 21.5962 36.4835 23.6939 34.6255 25.9643C33.4586 27.3921 31.9455 28.4057 30.0953 29.0068C27.7015 29.7841 25.9482 28.8601 25.9482 28.8601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9435 19.77L54.954 39.5374H48.312L48.4178 19.77H54.9435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.022 19.77H153.751V24.5841H148.147L148.203 39.7066H141.635L141.646 24.5841H136.022V19.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4284 19.7695V34.7175H73.087V39.6708H57.9556V19.7695H64.4284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.85 19.7695H116.197V31.6184C116.197 36.2367 112.004 39.7485 106.858 39.7485C101.713 39.7485 97.5151 36.2367 97.5151 31.6184V19.7695H103.977V31.6184C104.036 33.1257 105.329 34.4657 106.914 34.4657C108.497 34.4657 109.791 33.1257 109.85 31.6184V19.7695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5713 19.6323C90.5067 19.6323 95.3258 24.1391 95.3258 29.6905C95.3258 35.2419 90.5067 39.7487 84.5713 39.7487C78.6356 39.7487 73.8169 35.2419 73.8169 29.6905C73.8169 24.1391 78.6356 19.6323 84.5713 19.6323ZM84.5713 24.8359C82.1382 24.8359 80.1628 27.0112 80.1628 29.6905C80.1628 32.3698 82.1382 34.5451 84.5713 34.5451C87.0044 34.5451 88.9799 32.3698 88.9799 29.6905C88.9799 27.0112 87.0044 24.8359 84.5713 24.8359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.63 19.77L134.619 24.5841H125.456V27.6389L133.55 27.6315V32.2608H125.456V34.7991H135.007L135.029 39.6114H119.139L119.153 19.77H134.63Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_720_4301",
    x: -13.0725,
    y: -13.572,
    width: 205.844,
    height: 86.5244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.78624
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_720_4301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_720_4301",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_720_4301",
    x1: 0.5,
    y1: 29.6903,
    x2: 179.199,
    y2: 29.6903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7AC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE96FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderMobileLogo);
export default __webpack_public_path__ + "static/media/header-mobile-logo.7b39d6cac9712e84e3fa0e3ba1634eb6.svg";
export { ForwardRef as ReactComponent };